import PropTypes from 'prop-types';
import { ROUTES } from '@shared/constants';
import TextButton from '@components/TextButton';
import { StyledLink } from '../SignUp/styles';

const DEFAULT_CONTAINER_STYLE = {
  marginTop: 24,
  display: 'flex',
  justifyContent: 'center',
};

export default function BackToSignInLink({ t, containerStyle, id }) {
  return (
    <div style={containerStyle}>
      <StyledLink id={id} to={ROUTES.SIGN_IN}>
        <TextButton>
          {t('Authentication.Distribution.backToSignIn')}
        </TextButton>
      </StyledLink>
    </div>
  );
}

BackToSignInLink.defaultProps = {
  t: (key) => key,
  containerStyle: DEFAULT_CONTAINER_STYLE,
  id: 'back_to_signin_link',
};

BackToSignInLink.propTypes = {
  t: PropTypes.func,
  containerStyle: PropTypes.object,
  id: PropTypes.string,
};
